/*
 * This file is part of the Neos.Neos.Ui package.
 *
 * (c) Contributors of the Neos Project - www.neos.io
 *
 * This package is Open Source Software. For the full copyright and license
 * information, please view the LICENSE file which was distributed with this
 * source code.
 */
export {initializeI18n} from './initializeI18n';
export {requireGlobals} from './globals';
export {setupI18n} from './setupI18n';
export {teardownI18n} from './teardownI18n';
